// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__QClwY","circle":"Loader_circle__lZ6rO","spin":"Loader_spin__ddwRw","innerLoaderImage":"Loader_innerLoaderImage__lr38-"};